export const selectLabelingHistoryLoading = (state) =>
  state.labelingHistory.loading;
export const selectLabelingHistories = (state) =>
  state.labelingHistory.histories;

export const getAllHistoryLabelTypes = (state) =>
  state.labelingHistory.labelTypes || [];

export const getAllHistoryUsers = (state) => state.labelingHistory.users || [];

export const getHistoryShapes = (state) => state.labelingHistory.shapes || [];

export const getHistoryDisplayingShapes = (state) =>
  state.labelingHistory.displayingShapes || [];
